import React, { Component } from "react";
import EmailListService from "../../Email/EmailListService";
import { Button } from "reactstrap";
import { Modal, ToggleButton } from "react-bootstrap";
import { MDBInput } from "mdbreact";
import { toast } from "react-toastify";
import _ from "lodash";
import MailGunEmailTypes from "../../Email/Enums/MailGunEmailTypes";
import $ from "jquery";
export default class MG_EditEmailAliasModal extends Component {
  state = {
    myAlias: this.props.emailAlias,
    domain: this.props.domain || "",
    fetchingDomain: false // Add this flag

  };

  ///Called on Save Button Click
  closeModal = () => {
    let { emailAlias } = this.props;
    if (_.isEmpty(emailAlias)) {
      toast.error("Email Alias is Empty.");
      return;
    }
    this.props.handleClose();
  };
  saveValues =()=>{
    const { emailAlias } = this.props;
    const {domain} = this.state;
    if (_.isEmpty(emailAlias)) {
      toast.error("Email Alias is Empty.");
      return;
    }
    const { teamTypeId, entityType } = this.props;
    if (entityType === MailGunEmailTypes.Team && teamTypeId) {
      let currentDomain = domain.slice(1);
      this.props.saveAliasModalValues(currentDomain);
    }
    this.props.handleClose();
  }
  //Called on Cross button click
  onHide = () => {
    const { myAlias } = this.state;
    let { emailAlias } = this.props;

    this.props.setMgListAlias(myAlias);
    // if (_.isEmpty(emailAlias)) {
    //   toast.error("Email Alias is Empty.");
    //   return;
    // }
    this.props.handleClose();
  };
  //Called on Cancel Button
  onCancel = () => {
    const { myAlias } = this.state;
    let { emailAlias } = this.props;

    this.props.setMgListAlias(myAlias);
    // if (_.isEmpty(emailAlias)) {
    //   toast.error("Email Alias is Empty.");
    //   return;
    // }
    this.props.handleClose();
  };
  onShowModal = () => {
    this.getSubdomains();
    const { emailAlias } = this.props;
    this.setState({ myAlias: emailAlias });
  };
  getSubdomains = async () => {
    if (this.state.fetchingDomain) return; // Prevent multiple concurrent calls
    
    this.setState({ fetchingDomain: true });
    $(".loading").show();
    
    const { teamTypeId, entityType } = this.props;
    try {
      if (entityType === MailGunEmailTypes.Team && teamTypeId) {
        const { data: response } = await EmailListService.GetDomainName(teamTypeId);
        if (response.status === "success") {
          this.setState({ domain: response.domain });
        }
      } else {
        this.setState({ domain: this.props.domain });
      }
    } catch (ex) {
      console.log(ex);
      toast.error("Something went wrong!");
    } finally {
      $(".loading").hide();
      this.setState({ fetchingDomain: false });
    }
  };
  componentDidUpdate(prevProps) {
    if (
      !this.state.fetchingDomain && // Don't fetch if already fetching
      this.props.entityType === MailGunEmailTypes.Team &&
      (
        prevProps.teamTypeId !== this.props.teamTypeId ||
        prevProps.entityType !== this.props.entityType
      )
    ) {
      this.getSubdomains();
    }
  }
  render() {
    return (
      <Modal
        show={this.props.show}
        onHide={this.onHide}
        onShow={this.onShowModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Edit Email List Alias</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div class="input-group mb-3">
                <input
                  id="emailAlias"
                  type="text"
                  class="form-control"
                  placeholder="Email Alias"
                  aria-label="Email Alias"
                  aria-describedby="basic-addon2"
                  value={this.props.emailAlias}
                  onChange={this.props.handleEmailAliasChange}
                />
                <span class="input-group-text" id="basic-addon2">
                  {this.state.domain}
                </span>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <div className="form-group">
                <MDBInput
                  value={this.props.mailingListName}
                  name="mailingListName"
                  label="Mailing List Name (optional)"
                  group
                  type="text"
                  onChange={this.props.changeHandlerListName}
                ></MDBInput>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={this.onCancel}>
            Cancel
          </Button>
          <button className="btn btn-success w-md mc" onClick={this.saveValues}>
            Save
          </button>
        </Modal.Footer>
      </Modal>
    );
  }
}
